export default __webpack_public_path__ + "static/media/mps-2025-class-12-arts-result.1b9e47c5.jpg";